import typographyCommon from "./typographyCommon";

const mainFont = "Noto Sans TC";
// const mainFont = "MHeiHK";

const typographyZh = {
  fontFamily: [mainFont].join(","),
  // fontFamily: ["Arial"].join(","),
  // htmlFontSize: 10,
  // fontWeightBold: 900,
  banner: {
    fontSize: "2.6rem",
    letterSpacing: "7.56px",
    fontFamily: "HelveticaNeue-Ultra-Light",
    height: "2.7rem",
    color: "#B60E22",
    textShadow: "0px 0px 10px #C61B02 ",
  },
  shadowBanner: {
    fontSize: "5.5rem",
    fontFamily: mainFont,
    color: "#C11b0E",
    textShadow: "1px 2px 5px #8c0f01",
  },
  h1: {
    fontSize: "4.5rem",
    fontFamily: mainFont,
  },
  h2: {
    fontSize: "25px",
    fontWeight: 700,
    fontFamily: mainFont,
  },
  h3: {
    fontSize: "2.8rem",
    fontFamily: mainFont,
  },
  h4: {
    fontSize: "1.8rem",
    fontFamily: mainFont,
  },
  h5: {
    fontSize: "15px",
    fontWeight: 700,
    fontFamily: mainFont,
  },

  body1: {
    fontSize: "1rem",
    fontFamily: mainFont,
  },
  body2: {
    fontSize: "0.9rem",
    fontFamily: mainFont,
  },
  caption: {
    fontFamily: mainFont,
    fontSize: "0.77rem",
    lineHeight: 1.65,
    letterSpacing: "0em",
  },
  button: {
    fontFamily: mainFont,
    fontSize: "1rem",
    fontWeight: 700,
  },
  ...typographyCommon,
};

console.debug("typographyZh", typographyZh);

export default typographyZh;
